import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CursoService {

  // private baseUrl = 'http://127.0.0.1:8000/api';
  private baseUrl = 'https://backcursos.meds.cl/api'

  constructor(private http: HttpClient) { }

  obtenerCursos(): Observable<any> {
    return this.http.get(`${this.baseUrl}/`);
  }

  enviarSolicitudPago(datosPago: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.baseUrl}/pago-curso`, datosPago, { headers });

  }

  enviarToken(token: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.baseUrl}/recibir-token`, { token }, { headers });
  }

  getResponseTransaccion(token: string): Observable<any> {
    const url = `${this.baseUrl}/getResponseTransaccion/${token}`;
    // console.log('Construyendo URL para getResponseTransaccion:', url);
    return this.http.get(url);
  }
    
}
